import { skipToken } from '@reduxjs/toolkit/dist/query';
import { useQualificationByEmailQuery } from '../store/features/qualification/qualificationSlice';
import { useAppSelector } from '../store/hooks';
import { GuestUser, Qualification } from '../types/qualification';
import { getGuestUserEmail } from '../utils/qualification';

interface GuestUserFromStore {
  user?: GuestUser | null;
  qualification?: Qualification;
  isGuestUserFetching: boolean;
  canFetchGuestUser: boolean;
}
export const useGuestUserFromStore = (): GuestUserFromStore => {
  const guestUser = useAppSelector((state) => state.qualification.guestUser);

  return useQualificationByEmailQuery((guestUser?.email || getGuestUserEmail()) ?? skipToken, {
    selectFromResult: ({ isLoading, data }) => ({
      isGuestUserFetching: isLoading,
      qualification: data?.qualification,
      user: guestUser,
      canFetchGuestUser: Boolean(guestUser?.email || getGuestUserEmail()),
    }),
  });
};
